// extracted by mini-css-extract-plugin
export default {"root":"classes_root__szgWH","bottom-buttons":"classes_bottom-buttons__gmnX4"};